import { useEffect, useState } from "react";

export const Splash = ({ onDone }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      onDone && onDone();
    }, 1700);
    return () => clearTimeout(t);
  }, [onDone]);

  if (!visible) return null;
  return (
    <div className="vexen-splash" data-testid="splash-screen" style={{ background: "#070D18" }}>
      <div
        className="absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(212,175,55,0.10), rgba(7,13,24,0) 55%)",
        }}
      />
      <div className="relative z-10 flex flex-col items-center animate-fade-up">
        <img
          src="/vexen-logo-light.png"
          alt="Vexen"
          style={{
            width: "min(480px, 75vw)",
            height: "auto",
            objectFit: "contain",
            filter: "drop-shadow(0 18px 60px rgba(255,255,255,0.08))",
          }}
        />
      </div>
      <div className="absolute bottom-10 left-0 right-0 text-center z-10">
        <div className="text-[10px] uppercase tracking-[0.4em] text-slate-600 font-mono">
          by Scitus.ai
        </div>
      </div>
    </div>
  );
};
